import React from 'react';
import { motion } from 'framer-motion';
import { Lock, CreditCard, ShieldCheck } from 'lucide-react';
import { goToCheckout } from '../utils/checkout';
export function PriceCTA() {
  return <section id="pricing" className="py-24 px-4 relative" data-id="element-89">
      <div className="absolute inset-0 bg-radial-glow opacity-40 pointer-events-none" data-id="element-90" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-91">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-10 max-w-3xl mx-auto" data-id="element-92">
          <p className="text-xl md:text-2xl text-white font-display font-bold uppercase leading-snug" data-id="element-93">
            ¿Cuánto vale para ti recuperar un solo día operando al{' '}
            <span className="text-brand-orange" data-id="element-94">100% de tu capacidad</span>?
          </p>
          <p className="text-lg text-brand-muted mt-3" data-id="element-95">
            ¿Cuánto vale recuperar el respeto de tu propio cuerpo?
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-brand-darker border border-brand-orange/50 rounded-2xl p-8 md:p-16 text-center shadow-[0_0_50px_rgba(255,107,0,0.15)]" data-id="element-96">
          <h2 className="text-2xl md:text-4xl font-bold text-white uppercase tracking-wide mb-8" data-id="element-97">
            Acceso al Protocolo Alpha hoy por solo:
          </h2>

          <div className="flex justify-center items-start mb-6" data-id="element-98">
            <span className="text-4xl md:text-6xl font-bold text-brand-orange mt-2" data-id="element-99">
              $
            </span>
            <span className="text-8xl md:text-9xl font-display font-bold text-brand-orange leading-none" data-id="element-100">
              6.36
            </span>
          </div>

          <p className="text-brand-muted text-lg md:text-xl mb-10 font-medium uppercase tracking-wider" data-id="element-101">
            Pago único. Acceso inmediato. Versión Digital 2026.
          </p>

          <button onClick={goToCheckout} className="w-full md:w-auto bg-brand-orange hover:bg-[#ff7b1a] text-black font-display font-bold text-2xl md:text-3xl py-6 px-12 rounded-sm transition-all transform hover:scale-105 shadow-[0_0_30px_rgba(255,107,0,0.5)] uppercase tracking-wide mb-8" data-id="element-102">
            Sí, quiero el reset biológico por $6.36
          </button>

          <div className="flex flex-wrap justify-center items-center gap-6 text-brand-muted text-sm" data-id="element-103">
            <div className="flex items-center gap-2" data-id="element-104">
              <Lock className="w-4 h-4" data-id="element-105" />
              <span data-id="element-106">Pago 100% Seguro</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-107">
              <CreditCard className="w-4 h-4" data-id="element-108" />
              <span data-id="element-109">Tarjetas / PayPal</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-110">
              <ShieldCheck className="w-4 h-4" data-id="element-111" />
              <span data-id="element-112">Garantía de 30 días</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}